
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __exports as objectGetOwnPropertyNames } from '../../../_virtual/object-get-own-property-names.js';
export { __exports as default } from '../../../_virtual/object-get-own-property-names.js';
import objectKeysInternal from './object-keys-internal.js';
import enumBugKeys$1 from './enum-bug-keys.js';

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$1;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};
//# sourceMappingURL=object-get-own-property-names.js.map
